<template>
  <div class="good-need-main"  :class="isMobile ? `good-need-main-mobile ${data.className}` : data.className" :style="{ background: `${data.bgImage}` }">
    <div class="left">
      <div class="title">{{ data.title }}</div>
      <div class="content">{{ data.content }}</div>
    </div>
    <div class="right" :style="{ backgroundImage: `url(${data.icon})` }"> </div>
  </div>
</template>
<script>
  export default {
    name: 'GoodNeedsItem',
    props: {
      data: {
        type: Object,
        default: () => {}
      }
    }
  };
</script>
<style lang="scss" scoped>
  .good-need-main {
    display: flex;
    align-items: center;
    padding-left: 2.68rem;
    width: 100%;
    height: 4.53rem;
  }
  .left {
    margin-right: 3.85rem;
    .title {
      font-size: 0.43rem;
      font-family: PingFangTC-Medium, PingFangTC;
      font-weight: 500;
      color: #000000;
      line-height: 0.6rem;
      letter-spacing: 0.03rem;
      margin-bottom: 0.27rem;
    }
    .content {
      width: 6.3rem;
      font-size: 0.24rem;
      font-family: PingFangTC-Regular, PingFangTC;
      font-weight: 400;
      color: #8b8b8b;
      line-height: 0.48rem;
      letter-spacing: 1px;
      opacity: 0.3;
    }
  }
  .right {
    flex-shrink: 0;
    width: 2.77rem;
    height: 3.2rem;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .custom-class {
    flex-direction: row-reverse;
    .left {
      margin-right: 2.56rem;
      margin-left: 4.77rem;
      text-align: right;
    }
    .content {
      width: 6.4rem;
      text-align: right;
    }
  }
  .good-need-main-mobile {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    width: 100%;
    height: 10.58rem;
    padding-left: 0rem;
    .left {
      margin-right: 1.89rem;
      .title {
        font-size: 0.82rem;
        font-family: PingFangTC-Medium, PingFangTC;
        font-weight: 500;
        color: #000000;
        line-height: 1.13rem;
      }
      .content {
        width: 10.5rem;
        font-size: 0.61em;
        font-family: PingFangTC-Regular, PingFangTC;
        font-weight: 400;
        color: #8B8B8B;
        line-height: 0.98rem;
        letter-spacing: 0.05rem;
        opacity: 1;
      }
    }
    .right {
      margin-bottom: 1rem;
      margin-right: 1.38rem;
      flex-shrink: 0;
      width: 4.35rem;
      height: 4.97rem;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    &.custom-class {
      flex-direction: row;
      .left {
        margin-right: 1.13rem;
        margin-left: 1.02rem;
        text-align: left;
      }
      .content {
        width: 11.21rem;
        text-align: left;
      }
    }
  }
</style>
